'use client';
import { ComponentPropsWithRef, FunctionComponent } from 'react';
import { AppProgressBar } from 'next-nprogress-bar';

export const ProgressBar: FunctionComponent<ComponentPropsWithRef<typeof AppProgressBar>> = (
    props
) => {
    return <AppProgressBar {...props} />;
};
